import styled from "styled-components";

export const Wrapper = styled.div`
    height: 100%;
    display: flex;
    flex-direction: column;
    .wrapperHeader: {
        flex: 0 0 auto;
    }
    .wrapperBody: {
        flex: 1 1 auto;
        overflow: auto;
}
`;

export const WrapperHeader = styled.div`
    flex: 0 0 auto;
`;

export const WrapperBody = styled.div`
    flex: 1 1 auto;
    overflow: auto;
`;
